import { useMutation } from 'react-query';
import { ToastContext } from 'app/components/Context/ToastContext';
import { useContext } from 'react';
import { UploadCommunityImage } from 'services/apiServices';
import {
  TUploadImageResult,
  Errors,
} from 'types/ApiServicesTypes';

export default function useUploadCommunityImage() {
  const { showAlert } = useContext(ToastContext);

  const mutation = useMutation<TUploadImageResult, Errors, File>(
    ['UploadCommunityImage'],
    file =>
      UploadCommunityImage(file)
        .then(res => {
          showAlert!('Image uploaded successfully', 'success');
          return res;
        })
        .catch(err => {
          showAlert!(err.message as string);
          return err;
        }),
  );

  if (mutation.isError && mutation.error) {
    showAlert!(mutation.error.message);
  }

  return mutation;
} 